import React, {useContext} from 'react';

import { Props } from './NavigationButton.types';
import { Styled } from './NavigationButton.styles';

import navIcon from 'images/menu.svg';
import {mainCordovaContext} from "../../context";
import {useHistory} from "react-router";

export const NavigationButton: React.FC<Props> = (props) => {
  const { toggleNavigation } = useContext(mainCordovaContext);

  const history = useHistory();

  const handleClick = () => {
    history.push('/')
    toggleNavigation(true);
  }

  return (
    <Styled.NavigationButton onClick={handleClick}>
      <img alt="К главному меню" src={navIcon} />
    </Styled.NavigationButton>
  );
};